import * as React from 'react';

import { IconProps } from '../Icon';

export const QRCodeFilledIcon = ({ width, color }: IconProps): JSX.Element => {
  const DEFAULT_WIDTH = '18';
  const DEFAULT_COLOR = 'none';

  return (
    <svg
      aria-hidden="true"
      fill={color || DEFAULT_COLOR}
      height={width || DEFAULT_WIDTH}
      viewBox="0 0 24 24"
      width={width || DEFAULT_WIDTH}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="rgb(0,0,0)">
        <g clipRule="evenodd" fillRule="evenodd">
          <path d="m2 3c0-.55228.44772-1 1-1h7c.5523 0 1 .44772 1 1v7c0 .5523-.4477 1-1 1h-7c-.55228 0-1-.4477-1-1zm3 3c0-.55228.44772-1 1-1h1c.55228 0 1 .44772 1 1v1c0 .55228-.44772 1-1 1h-1c-.55228 0-1-.44772-1-1z" />
          <path d="m2 14c0-.5523.44772-1 1-1h7c.5523 0 1 .4477 1 1v7c0 .5523-.4477 1-1 1h-7c-.55228 0-1-.4477-1-1zm4 2c-.55228 0-1 .4477-1 1v1c0 .5523.44772 1 1 1h1c.55228 0 1-.4477 1-1v-1c0-.5523-.44772-1-1-1z" />
          <path d="m14 2c-.5523 0-1 .44772-1 1v7c0 .5523.4477 1 1 1h7c.5523 0 1-.4477 1-1v-7c0-.55228-.4477-1-1-1zm2 4c0-.55228.4477-1 1-1h1c.5523 0 1 .44772 1 1v1c0 .55228-.4477 1-1 1h-1c-.5523 0-1-.44772-1-1z" />
        </g>
        <path d="m14 13c-.5523 0-1 .4477-1 1v1c0 .5523.4477 1 1 1h1v2c0 .5523.4477 1 1 1h1c.5523 0 1-.4477 1-1v-2c0-.5523-.4477-1-1-1h-1v-1c0-.5523-.4477-1-1-1z" />
        <path d="m14 19c-.5523 0-1 .4477-1 1v1c0 .5523.4477 1 1 1h1c.5523 0 1-.4477 1-1v-1c0-.5523-.4477-1-1-1z" />
        <path d="m18 14c0-.5523.4477-1 1-1h1c.5523 0 1 .4477 1 1v1c0 .5523-.4477 1-1 1h-1c-.5523 0-1-.4477-1-1z" />
        <path d="m19 19c-.5523 0-1 .4477-1 1v1c0 .5523.4477 1 1 1h1c.5523 0 1-.4477 1-1v-1c0-.5523-.4477-1-1-1z" />
      </g>
    </svg>
  );
};
